import { Link } from "react-router-dom";
import { transformRoute } from "helpers";
import { Contact } from "services/api/contacts/types";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";

export const WAREHOUSE_CONTACT_LIST_COLUMNS = (
    contacts: Contact[],
    onRemove: (index: number) => void
): Column[] => [
    {
        title: "Kontakt",
        field: "",
        type: ColumnTypes.custom,
        render: (row: Contact) => (
            <Link
                to={transformRoute(ContactRoutes.ContactDetailPageRouter, { id: row.id })}
                className="text-sm font-medium text-sky-600 hover:text-sky-900"
            >
                {row.firstName} {row.lastName}
            </Link>
        ),
    },
    {
        title: "Tvrtka",
        field: "",
        type: ColumnTypes.custom,
        render: (row: Contact) => (
            <span className="text-sm text-slate-500">{row.companyName ?? "-"}</span>
        ),
    },
    {
        title: "",
        field: "",
        type: ColumnTypes.custom,
        render: (row: Contact) => {
            const index = contacts.findIndex((c) => c.id === row.id);
            return (
                <ButtonMenu endIcon="/media/icons/more-dots.svg" cssClassName="h-full" variant="text">
                    <ButtonMenuItem startIcon="/media/icons/trash.svg" variant="remove" onClick={() => onRemove(index)}>
                        Ukloni
                    </ButtonMenuItem>
                </ButtonMenu>
            );
        },
    },
];
